import { csrfFetch } from './csrf.js';
import { gcoreServerUrl } from '../config';

const alarmUrl = `${gcoreServerUrl}/api/subMatFolderAlarmEmails`;

export const bulkCreateDirect = async ({ gclientId, folderId, subMatFolderAlarmEmails }) => {
  const response = await csrfFetch(null, `${alarmUrl}/bulk`, {
    method: 'POST',
    body: JSON.stringify({ gclientId, folderId, subMatFolderAlarmEmails }),
  });
  const data = await response.json();
  return data.subMatFolderAlarmEmails || [];
};

export const selectDirect = async ({ gclientId, folderId } = {}) => {
  const qs = new URLSearchParams();
  if (gclientId) qs.set('gclientId', gclientId);
  if (folderId) qs.set('folderId', folderId);
  const q = qs.toString();
  const response = await csrfFetch(null, `${alarmUrl}${q ? `?${q}` : ''}`);
  const data = await response.json();
  return data.subMatFolderAlarmEmails || [];
};

export const removeDirect = async (id) => {
  const response = await csrfFetch(null, `${alarmUrl}/${id}`, {
    method: 'DELETE',
  });
  const data = await response.json();
  return data.subMatFolderAlarmEmail;
};

export const formatAlarmPeriodLabel = (alarm) => {
  if (!alarm) return '';
  const period = alarm.period;
  if (period == null) return '';
  if (alarm.type === 'W') return `${period} 주 전`;
  if (alarm.type === 'M') return `${period} 개월 전`;
  return `${period} 일 전`;
};
